import React, { useState } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Home from './components/Home';
import Login from './components/Login';
import PrivateRoute from './routes/PrivateRoute';
import { AuthContext } from './context/authContext';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default function App() {
  const [authTokens, setAuthTokens] = useState();

  const setTokens = (data) => {
    setAuthTokens(data);
  };

  return (
    <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens, googleClientId }}>
      <BrowserRouter>
        <Route path="/login" component={Login} />
        <PrivateRoute exact path="/" component={Home} />
      </BrowserRouter>
    </AuthContext.Provider>
  );
}
